export type PromotionResponse = {
  type: string;
  message: string;
  link: string;
  showMessage: boolean;
}

